import * as React from 'react';
import { createRoot } from 'react-dom/client';
import type { NonInteractiveContinueHandlerType, NonInteractiveRenderViewReturnType, RenderViewPropsType, RenderViewReturnType } from '../types';
import { UserMessage } from '../../../React/features/Chat/features/UserMessage';

export const COMPONENT_IDENTIFIER = 'user-message';
const COMPONENT_ROOT_CLASS_NAME = `chat-${COMPONENT_IDENTIFIER}-container`;

export type RenderUserMessagePropsType = RenderViewPropsType<{
  messageElement: React.ReactNode;
}>

export const renderUserMessage = async (props: RenderUserMessagePropsType): RenderViewReturnType<NonInteractiveRenderViewReturnType> => {
  const { chatRoot, keyName } = props;

  // レンダーするためのルート要素を作成
  const viewContainer = document.createElement('div');
  const viewRoot = createRoot(viewContainer);

  // 表示関連のフラグを作成
  const isFirstElement = chatRoot.children.length === 0;
  const isConsecutive = chatRoot.lastElementChild?.classList.contains(COMPONENT_ROOT_CLASS_NAME) || false;

  // コンテナ要素にクラス付与
  viewContainer.classList.add(COMPONENT_ROOT_CLASS_NAME);
  viewContainer.classList.add(keyName);

  // チャットルートにコンテナ要素をappendする
  chatRoot.appendChild(viewContainer);

  return new Promise((resolve) => {
    const continueHandler = (args: NonInteractiveContinueHandlerType) => resolve({ ...args, viewRootDomReference: viewContainer });

    // appendしたコンテナ要素にJsxをレンダリングする
    viewRoot.render(<UserMessage {...props} continueHandler={continueHandler} isFirstElement={isFirstElement} isConsecutive={isConsecutive} />);
  });
};
